export const SET_ALL_TASK = 'SET_ALL_TASK';
export const ADD_TASK = 'ADD_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK'; 
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK';


export const setAllTask = (task) => ({
  type: SET_ALL_TASK,
  payload: task,
});

export const addNewTask = (newTask) => ({
  type: ADD_TASK,
  payload: newTask,
});


export const updateTask = (updatedtask) => ({
  type: UPDATE_TASK,
  payload: updatedtask,
});


export const deleteTask = (taskId) => ({ 
  type: DELETE_TASK,
  payload: taskId,
});

export const setSelectedT = (task) => ({
  type: SET_SELECTED_TASK,
  payload: task,
});
